import {
  getExploreBody,
  getExploreHeader,
  getExploreIntentLabel,
  isQueryToolActive,
  isQueryToolCall,
  type ThinkContentItem,
} from "./ToolCallCard.tools";
import { CollapsibleActionRow } from "./ToolCallCardCollapsibleActionRow";

type ExploreActionRowProps = {
  item: ThinkContentItem;
};

/** Inline explore line for internal query_* tool calls. */
export function ExploreActionRow({ item }: ExploreActionRowProps) {
  if (!isQueryToolCall(item)) {
    return null;
  }

  const isActive = isQueryToolActive(item);
  const intent = getExploreIntentLabel(item);
  const header = isActive ? `Exploring · ${intent}` : getExploreHeader(item);

  // A search that could not run is a step the agent recovers from, not a
  // failure of the turn: its history already says what went wrong, so it is
  // not repeated in red beneath the row.
  return (
    <CollapsibleActionRow
      header={header}
      body={getExploreBody(item)}
      isActive={isActive}
    />
  );
}
